'use strict';
var globalThis = require('../internals/global-this');
var isObject = require('../internals/is-object');

var document = globalThis.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/document-create-element.js
// module id = 123
// module chunks = 22